import { clearCandidateSession } from "../../auth/candidateSession";
import { getUser } from "./getUser";

const refreshEndpoint =
  (process.env.REACT_APP_API_URL || "") + "/session/refresh-token";

const REFRESH_NOT_FOUND = "Refresh token não encontrado para este usuário.";

function clearSessionAndGoHome() {
  clearCandidateSession();
  window.location.replace("/");
}

export async function refreshAccessTokenSilently(): Promise<string | null> {
  const { refreshToken } = getUser();
  if (!refreshToken) return null;

  try {
    const res = await fetch(refreshEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
    if (!res.ok) return null;
    const data = await res.json();
    const newToken = data?.token;
    const newRefreshToken = data?.refresh_token;
    if (newToken) {
      localStorage.setItem("rh-token", newToken);
      if (newRefreshToken != null) {
        localStorage.setItem("rh-refreshToken", newRefreshToken);
      }
      return newToken;
    }
    return null;
  } catch {
    return null;
  }
}

export async function refreshAccessToken(): Promise<string | null> {
  const { refreshToken } = getUser();
  if (!refreshToken) return null;

  try {
    const res = await fetch(refreshEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
    if (res.status === 400) {
      const data = await res.json().catch(() => ({}));
      if (data?.error === REFRESH_NOT_FOUND) {
        clearSessionAndGoHome();
        return null;
      }
    }
    if (!res.ok) return null;
    const data = await res.json();
    const newToken = data?.token;
    const newRefreshToken = data?.refresh_token;
    if (newToken) {
      localStorage.setItem("rh-token", newToken);
      if (newRefreshToken != null) {
        localStorage.setItem("rh-refreshToken", newRefreshToken);
      }
      return newToken;
    }
    return null;
  } catch {
    return null;
  }
}
